import dayjs from 'dayjs';
import _ceil from 'lodash/ceil';
import _orderBy from 'lodash/orderBy';
import dao from '../../../../dao/smbpartner/linkDao';
import smbUtils from '../../../../utils/smbUtils';
import partnerUtils from '../../../../utils/partnerUtils';

const LIST_LINKS = 'pages/partner/linkbuilder/history/LIST_LINKS';
const LIST_LINKS_SUCCESS =
  'pages/partner/linkbuilder/history/LIST_LINKS_SUCCESS';
const FILTER_LINKS = 'pages/partner/linkbuilder/history/FILTER_LINKS';
const FILTER_LINKS_SUCCESS =
  'pages/partner/linkbuilder/history/FILTER_LINKS_SUCCESS';
const DELETE_LINK = 'pages/partner/linkbuilder/history/DELETE_LINK';
const DELETE_LINK_SUCCESS =
  'pages/partner/linkbuilder/history/DELETE_LINK_SUCCESS';
const SEARCH = 'pages/partner/linkbuilder/history/SEARCH';
const RESET_SEARCH = 'pages/partner/linkbuilder/history/RESET_SEARCH';
const SET_REFERRAL_CODE = 'pages/partner/linkbuilder/history/SET_REFERRAL_CODE';
const PAGE = 'pages/partner/linkbuilder/history/PAGE';
const SIZE = 'pages/partner/linkbuilder/history/SIZE';
const SORT = 'pages/partner/linkbuilder/history/SORT';

const initialState = {
  links: [],
  allLinks: [],
  isLoaded: true,
  grid: {
    sort: 'createdTime',
    asc: false,
    pageIndex: 1,
    pageSize: 10,
    querySize: 100,
    pages: 1,
    totalSize: 0,
  },
  searchParams: {
    referralLink: '',
  },
  referralCode: '',
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case LIST_LINKS:
      return {
        ...state,
      };
    case LIST_LINKS_SUCCESS:
      return {
        ...state,
        links: action.json.results,
        allLinks: action.json.results,
      };
    case FILTER_LINKS:
      return {
        ...state,
      };
    case FILTER_LINKS_SUCCESS:
      return {
        ...state,
        links: action.json,
        grid: {
          ...state.grid,
          totalSize: action.json.length,
          pages: _ceil(action.json.length / state.grid.pageSize),
        },
      };
    case DELETE_LINK:
      return {
        ...state,
      };
    case DELETE_LINK_SUCCESS:
      return {
        ...state,
      };
    case SEARCH:
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          ...action.params,
        },
        grid: {
          ...state.grid,
          pageIndex: 1,
        },
      };
    case RESET_SEARCH:
      return {
        ...state,
        searchParams: {
          referralLink: '',
        },
      };
    case SET_REFERRAL_CODE:
      return {
        ...state,
        referralCode: action.referralCode,
      };
    case PAGE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageIndex: action.pageIndex,
        },
      };
    case SIZE:
      return {
        ...state,
        grid: {
          ...state.grid,
          pageSize: action.pageSize,
          pages: _ceil(state.links.length / action.pageSize),
          pageIndex: 1,
        },
      };
    case SORT:
      return {
        ...state,
        grid: {
          ...state.grid,
          sort: action.sort,
          asc: state.grid.sort === action.sort ? !state.grid.asc : false,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export function listLinks() {
  return (dispatch, getState) => {
    dispatch({
      type: LIST_LINKS,
    });
    return dao
      .listAllLinks(buildQueryString(getState()))
      .then(json => dispatch(listLinksSuccess(json)));
  };
}

function listLinksSuccess(json) {
  return dispatch => {
    dispatch({
      type: LIST_LINKS_SUCCESS,
      json,
    });
    return dispatch(filterLinks());
  };
}

function buildQueryString(rootState) {
  const grid = rootState.pages.partner.linkbuilder.history.grid;
  return {
    sortBy: grid.sort,
    asc: grid.asc,
    pageIndex: initialState.grid.pageIndex,
    pageSize: grid.querySize,
  };
}

export function deleteLink(linkId) {
  return dispatch => {
    dispatch({type: DELETE_LINK});
    return dao.deleteLink(linkId).then(json => {
      dispatch({type: DELETE_LINK_SUCCESS, json});
      return dispatch(listLinks());
    });
  };
}

export function page(params) {
  return {
    type: PAGE,
    pageIndex: params.selected + 1,
  };
}

export function size(pageSize) {
  return {
    type: SIZE,
    pageSize,
  };
}

export function sort(sort) {
  return dispatch => {
    dispatch({
      type: SORT,
      sort,
    });
    return dispatch(filterLinks());
  };
}

function filterLinks() {
  return (dispatch, getState) => {
    const grid = getState().pages.partner.linkbuilder.history.grid;
    const ref = getState().pages.partner.linkbuilder.history.referralCode;
    let links = getState().pages.partner.linkbuilder.history.allLinks;
    const filterParams = smbUtils.omit(
      getState().pages.partner.linkbuilder.history.searchParams
    );
    if (filterParams.referralLink) {
      links = links.filter(l => {
        const url = partnerUtils.genReferralLink(
          ref,
          l.source,
          l.medium,
          l.campaign,
          l.content
        );
        return (
          url.search(
            new RegExp(
              partnerUtils.escapeRegExp(filterParams.referralLink),
              'i'
            )
          ) !== -1
        );
      });
    }
    if (filterParams.createdTimeFrom) {
      links = links.filter(l => {
        const from = dayjs(filterParams.createdTimeFrom).valueOf();
        const to = dayjs(filterParams.createdTimeTo).valueOf();
        const createdTime = dayjs(l.createdTime).valueOf();
        return from <= createdTime && createdTime <= to;
      });
    }
    links = _orderBy(links, grid.sort, grid.asc ? 'asc' : 'desc');
    return dispatch(filterLinksSuccess(links));
  };
}

function filterLinksSuccess(json) {
  return {
    type: FILTER_LINKS_SUCCESS,
    json,
  };
}

export function search(params) {
  return dispatch => {
    dispatch({
      type: SEARCH,
      params,
    });
    return dispatch(filterLinks());
  };
}

export function resetSearch() {
  return dispatch => {
    dispatch({
      type: RESET_SEARCH,
    });
    return dispatch(filterLinks());
  };
}

export function setReferralCode(referralCode) {
  return {
    type: SET_REFERRAL_CODE,
    referralCode,
  };
}
